<template>
  <div class="payment-result-page white-theme">
    <div class="result-card">
      <div class="result-icon success">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="16 10 10.5 15 8 12.5"/>
        </svg>
      </div>
      <h1 class="result-title">{{ $t('payment.success.title') }}</h1>
      <p class="result-message">{{ $t('payment.success.message') }}</p>
      <div class="result-actions">
        <router-link to="/" class="btn btn-primary btn-lg">{{ $t('payment.success.goHome') }}</router-link>
        <router-link to="/profile" class="btn btn-secondary btn-lg">{{ $t('payment.success.viewProfile') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import GA from '@/utils/ga'

export default {
  name: 'PaymentSuccess',
  mounted() {
    var urlParams = new URLSearchParams(window.location.hash.split('?')[1] || '')
    var sessionId = urlParams.get('session_id')
    if (sessionId) {
      console.log('Payment session:', sessionId)
    }
    var userInfo = this.$store.state.userInfo
    GA.paymentSuccess(userInfo ? userInfo.id : '', '', 0)
  }
}
</script>

<style scoped>
.payment-result-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}
.result-card {
  max-width: 480px;
  text-align: center;
  padding: 48px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
}
.result-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.result-icon.success {
  background: rgba(5, 150, 105, 0.1);
  color: var(--accent);
}
.result-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
}
.result-message {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 32px;
}
.result-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
